import { ApiClient, Auth } from '@pwcc/common-components';

import { AUTH_BASE_URL, MOBILE_BASE_URL } from './env';

export const auth = new Auth(AUTH_BASE_URL, MOBILE_BASE_URL, 'v2');
export const apiClient = new ApiClient(auth, '');
apiClient.service.defaults.withCredentials = false;
